<template>
  <div class="d-flex flex-column align-items-center">
    <div class='main-content'>
      <el-steps :active="step" align-center finish-status="success" class="d-flex justify-content-center">
        <el-step title="Team Details"></el-step>
        <el-step v-show="hasAdditionalQs > 0" title="Additional Questions"></el-step>
        <el-step v-show="hasSaleableItems > 0" title="Store"></el-step>
        <!-- <el-step title="Summary & Payment"></el-step> -->
      </el-steps>
      <content-body-card>
        <team-details v-if="step === 0" :value="registration" :member="member" :memberId="memberId" :event="selectedEvent" @update-step="updateStep" @tc-update="updateButtonStatus" ref="rego"/>
        <additional-questions v-if="step === 1" :value="registration" @update-step="updateStep" ref="rego"/>
        <store v-if="step === 2" :value="registration" @update-step="updateStep" ref="rego" @update-store="updateButtonStatus"/>
        <!-- <payment v-if="step === 3" :value="registration" @update-step="updateStep" :event="selectedEvent" ref="rego"/> -->
        <el-row class="mt-10">
          <el-divider></el-divider>
          <el-row :span="24" class="d-flex mt-10" :gutter="20">
            <el-col :span="12" class="d-flex justify-content-end">
              <el-button class="bottomBtn respBtn" @click="back">Back</el-button>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" :class="isNextDisabled ? 'bottomBtn disabled-next' : 'btn-highlight bottomBtn'" @click.prevent="next" :disabled="isNextDisabled">
                Next
              </el-button>
            </el-col>
          </el-row>
        </el-row>
      </content-body-card>
      <!-- <div class="payment-card" v-else>
        <payment v-if="step === 3" :value="registration" @update-step="updateStep" ref="rego"/>
        <el-row class="mt-10 mx-10">
          <el-divider></el-divider>
          <el-row :span="24" class="d-flex mt-10" :gutter="20">
            <el-col :span="12" class="d-flex justify-content-end">
              <el-button class="bottomBtn" @click="back">Back</el-button>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" class="btn-highlight bottomBtn" @click.prevent="next">
                {{ step === 3 ? 'Pay & Complete' : 'Next' }}
              </el-button>
            </el-col>
          </el-row>
        </el-row>
      </div> -->
    </div>
    <el-dialog
    v-if="showInviteModal"
    title="Team Products"
    :visible.sync="showInviteModal"
    width="30%"
    :show-close="false"
  >

    <!-- Products dialog content -->
    <template >
  <div class="w-100 products-dialog d-flex flex-column gap-10">
    <!-- a select to select member first -->
    <!-- header -->
    <div class="">
      <h2 class="break-word">Select member</h2>
      <el-select v-model="selectedmemberId" placeholder="Select a member" class="w-100" @change="updateSelectedMember">
  <el-option
    v-for="member in memberList"
    :key="member._id"
    :label="getMemberLabel(member)"
    :value="member._id"
  />
</el-select>
    </div>

    <h2 class="break-word">Select the product you would like to register for:</h2>
      <div class="product-cards " v-for="p in teamProducts" :key="p._id">
        <div class="product-container"
          @click="handleCardClicked(p) ">
          <el-card>
            <div class="product-container-main-mobile pb-05">
              <div class="d-flex justify-content-between ">

                <div class="product-description">
                  <!-- <i class="el-icon-s-data"></i> -->
                  <div class="d-flex gap-1 tag mr-1 member-type">
                    <span>
                      <el-tag class="" v-if="p.memberType">
                        {{ p.memberType? capitalize(p.memberType) : ''   }}
                      </el-tag>
                    </span>
                  </div>
                  <div class="d-flex gap-1 tag justify-content-evenly mr-1 gender">
                    <span v-if="p.gender && p.gender !== 'undefined'">
                      <el-tag class="">
                        {{ p.gender? p.gender === 'All' ? 'All Genders': capitalize(p.gender) : '' }}
                      </el-tag>
                    </span>
                  </div>
                  <div class="d-flex gap-1  tag mr-1 age">
                    <span>
                      <el-tag class="">
                        Age {{ p.ageFrom }} {{p.ageTo !== 99 ?  `- ${p.ageTo}` : '+'}}
                      </el-tag>
                    </span>
                  </div>
                </div>
                <div class="mr-10 mt-10">
                  <span class="f-bold fs-10">
                    {{ priceFormatted(p.price) }}
                  </span>
                </div>
              </div>
              <div class="product-description">
                <span>
                  {{ p.name }}
                </span>
              </div>
            </div>
            <div v-show="true || p.showMoreDetails" :key="key" class="">
              <div class="" v-if="p.tags && p.tags.length > 0">
                <span v-for="tag in p.tags" :key="tag._id">
                  <span class="ml-05 product-tag" @click="searchByTag(tag)">
                    #{{ tag.name }}
                  </span>
                </span>
              </div>
              <div class="d-flex gap-1 justify-content-between align-items-end ">
              </div>

            </div>
            <div class="rego-flags px-10 d-flex justify-content-end f-bold">
              <el-button
                size="mini"
                v-if="['indv-to-team', 'entity'].includes(p.type)"
                :type="getButtonType(p)"
                :disabled="getButtonLabel(p) === 'Already Registered' || getButtonLabel(p) === 'Ineligible' || getButtonLabel(p) === 'Closed'"
              >
                {{ getButtonLabel(p) }}
              </el-button>
              <span class="icons ml-05" v-if="['Already Registered', 'Closed', 'Required', 'Ineligible'].includes(getButtonLabel(p))">
                <fa-icon v-if="getButtonLabel(p) == 'Required'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                <fa-icon v-else-if="getButtonLabel(p) == 'Closed'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                  <fa-icon v-else-if="getButtonLabel(p) == 'Ineligible'" style="color:#E6A23C"
                  :icon="['fal', 'circle-exclamation']" />
                <fa-icon v-else-if="getButtonLabel(p) == 'Already Registered'" style="color:#67C23A"
                  :icon="['fal', 'circle-check']" />
              </span>
            </div>
          </el-card>
        </div>
      </div>
  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="closeDialog">Skip</el-button>
  </span>
</template>
  </el-dialog>
  </div>
</template>

<script>
import _ from 'lodash';
import { calculateMemberAge } from '@/utils/helpers';
import moment from 'moment';
import TeamDetails from './1-TeamDetails.vue';
import AdditionalQuestions from './2-AdditionalQuestions.vue';
import Store from './3-Store.vue';
// import Payment from './4-Payment.vue';

export default {
  name: 'RegisterTeam',
  components: {
    TeamDetails,
    AdditionalQuestions,
    Store,
    // Payment
  },
  props: {
    criteria: String,
    memberId: Number,
    selectedEvent: Object,
    member: Object,
  },
  data() {
    return {
      capitalize: _.capitalize,
      step: 0,
      registration: {
        eventId: undefined,
        productType: undefined,
        tags: undefined,
        team: undefined,
        product: undefined,
        additionalQs: undefined,
        saleableItems: undefined,
        discounts: undefined,
        meta: undefined
      },
      isNextDisabled: true,
      showInviteModal: false,
      selectedMember: this.$store.getters['user/activeMember'],
      teamProducts: [],
      selectedTeam: undefined,
      memberList: [],
      memberMembership: [],
      selectedmemberId: undefined,
      pendingNextAction: false,

    };
  },
  async mounted() {
    const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
    if (!this.selectedEvent) this.$router.push({ name: pathName });
    await this.getMemberList();
  },
  methods: {
    getMemberLabel(member) {
      const name = `${member.profile.firstName} ${member.profile.lastName}`;
      const age = this.calculateAge(member.profile.dob);
      const gender = member.profile.gender || 'Not specified';
      return `${name} (${age} years, ${gender})`;
    },

    // Make sure you have this method if it's not already defined
    getButtonType(product) {
      const label = this.getButtonLabel(product);
      switch (label) {
        case 'Already Registered':
        case 'Ineligible':
        case 'Closed':
          return 'info';
        case 'Required':
          return 'warning';
        case 'Pay Now':
        case 'Join':
        case 'Register':
          return 'primary';
        default:
          return 'default';
      }
    },
    async updateSelectedMember() {
      this.memberMembership = [];
      this.selectedMember = this.memberList.find((m) => m._id === this.selectedmemberId);
      this.$store.commit('user/setActiveMember', this.selectedMember);
      const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.selectedmemberId}`);
      this.memberMembership = response.data.data;
      this.$store.commit('user/setMemberRegos', this.memberMembership);
      // this.$store.commit('user/setMemberRegos', this.memberMembership);
      this.$forceUpdate();
    },
    checkPayAfter(productId) {
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        // console.log('found', found);
        // return true and the found membership
        if (found[0].payAfter && found[0].payAfterMeta.fullyPaid === false) {
          return true;
        }
      }
      return false;
    },
    async getMemberList() {
      const response = await this.$http.get('/assemble/api/v1/account/portal/members');
      this.memberList = response.data.data;
      if (!this.selectedmemberId) {
        const activeMember = this.$store.getters['user/activeMember'];
        if (activeMember && activeMember._id) {
          this.selectedmemberId = activeMember._id;
        }
        // this.memberId = activeMember._id;
      }
    },
    checkFullSlot(product) {
      // get items in the cart
      const pendingRegos = this.$store.getters['cart/registrations'];
      const numberOfSameProduct = pendingRegos.filter((r) => r.product._id === product._id).length;
      const foundProduct = this.localRegistration.product.find((p) => p._id === product._id);
      const isNoMax = _.get(this, 'localRegistration.noMax');
      if (!foundProduct) return false;
      if (foundProduct.type === 'team' && !isNoMax) {
        const numOfTeams = _.get(this, 'localRegistration.teams', []).length + numberOfSameProduct;
        const maxNoTeams = _.get(this, 'localRegistration.maxNoTeams');
        if (numOfTeams !== 0 && maxNoTeams !== 0 && numOfTeams >= maxNoTeams) {
          return true;
        }
      }
      if (foundProduct.type === 'indv-to-team' && !isNoMax) {
        const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
        const maxNoIndvTeam = _.get(this, 'localRegistration.maxNoIndvTeam');

        // Get team counts from registrationCounts data
        const indvToTeamData = _.get(registrationCounts, 'indvToTeamPerProduct', []);
        const teamCounts = _.countBy(indvToTeamData, 'teamId');

        // Find if any team has fewer registrations than maxNoIndvTeam
        const teamsBelowMaxLimit = _.pickBy(teamCounts, (count) => count < maxNoIndvTeam);

        // If there are no teams below the max limit, then the product is full
        if (_.isEmpty(teamsBelowMaxLimit) && teamCounts > 0) {
          return true;
        }
      }
      if (foundProduct.type === 'indv' && !isNoMax) {
        const registrationCounts = _.get(this, 'localRegistration.registrationCounts', {});
        const maxProductRego = _.get(foundProduct, 'maxRego', 0);
        const noOfIndv = _.get(registrationCounts, 'totalIndv', 0) + numberOfSameProduct;

        // Get product-specific count for maxProductRego check
        const productCount = _.get(registrationCounts, 'indvPerProduct', [])
          .find((item) => item.productId === foundProduct._id);
        const noOfIndvSameProd = (productCount ? productCount.count : 0) + numberOfSameProduct;

        const maxNoIndv = _.get(this, 'localRegistration.maxNoIndividuals');
        // console.log('maxProdcut Rego', maxProductRego);
        // console.log('noOfIndv', noOfIndv);
        if (noOfIndv !== 0 && maxNoIndv !== 0 && noOfIndv >= maxNoIndv) {
          return true;
        }
        if (maxProductRego !== 0 && noOfIndvSameProd >= maxProductRego) {
          // console.log('full slot');
          return true;
        }
      }
      return false;
    },
    priceFormatted(price) {
      // price currently in cents
      return `$${(price / 100).toFixed(2)}`;
    },
    tagsFormatted(tags) {
      // tags is an array containing objects
      return tags.map((tag) => tag.name).join(', ');
    },
    typeFormatter(type) {
      if (type === 'indv') return 'Become a member';
      if (type === 'indv-to-team') return 'Join a team';
      if (type === 'team') return 'Register a team';
      return '';
    },
    getButtonLabel(product) {
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullTeamSlot = this.checkFullSlot(product);
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      // const canJoinWaitingList = this.checkIsWaitlistOpen(product);

      if (isRegistered && !isPayAfter) {
        return 'Already Registered';
      }
      if (!isEligible) {
        return 'Ineligible';
      }
      if (fullTeamSlot) {
        return 'Full';
      }
      if (!product.isActive || !product.isRegoOpen) {
        return 'Closed';
      }
      if (isMembershipRequired && !isRegistered) {
        return 'Required';
      }
      if (isRegistered && isPayAfter) {
        return 'Pay Now';
      }
      if (product.type === 'indv-to-team') {
        return 'Join';
      }
      return 'Register';
    },
    checkProductVisibility(product) {
      if (this.privateProps.entityId && this.privateProps.productId) return true;
      if (_.get(product, 'isPrivate')) {
        if (product.isVisible !== undefined) {
          if (product.isVisible) return true;
          return false;
        }
      }
      return true;
    },
    checkRegistered(productId) {
      // console.log('checkRegistered', productId);
      // console.log('this.memberMembership', this.memberMembership);
      const product = this.localRegistration.product.find((p) => p._id === productId);
      const multipleRegoAllowed = this.$store.getters['national/getMultipleRegoAllowed'];
      const found = this.memberMembership
        .filter((m) => _.get(m, 'regoEntity.products._id') === productId
          && m.expired !== true);
      if (found.length) {
        if (multipleRegoAllowed && product.type === 'indv-to-team') {
          return false;
        }
        // return true and the found membership
        return true;
      }

      return false;
    },
    checkIndvTeamRegistered(product, teamId) {
      console.log('checkIndvTeamRegistered', product, teamId);
      const foundIndvTeamRegistration = this.memberMembership
        .find((m) => _.get(m, 'regoEntity.products._id') === product._id
          && m.expired !== true
          && m.team._id === teamId);
      if (foundIndvTeamRegistration) {
        return true;
      }
      return false;
    },
    handleCardClicked(product) {
      console.log('handleCardClicked', product);
      const isMembershipRequired = this.isMembershipRequired(product);
      const isRegistered = this.checkRegistered(product._id);
      const isPayAfter = this.checkPayAfter(product._id);
      const isEligible = this.isEligible(product);
      const fullSlot = this.checkFullSlot(product);

      if (isRegistered && !isPayAfter) {
        this.$notify({
          title: 'Already Registered',
          message: 'You are already registered for this product.',
          type: 'success',
          duration: 5000,
        });
        return;
      }
      // console.log('canJoinWaitingList', product.isWaitlistOpen, !isRegistered, !isNotEligible, product.isRegoOpen);
      if (!isEligible) {
        this.$notify({
          title: 'Ineligible',
          message: 'You are not eligible to register for this product.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (!product.isActive || !product.isRegoOpen) {
        this.$notify({
          title: 'Registration Closed',
          message: 'Registration for this product is closed. Please contact your administrator.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (isMembershipRequired && !isRegistered) {
        this.$confirm('Membership is required to join this event/membership. Do you want to register the required membership? ', 'Membership Required', {
          confirmButtonText: 'Get Membership',
          cancelButtonText: 'No',
          type: 'warning',
        }).then(async () => {
          console.log('membershuip required', product.membershipProductsRequired);
          const regoObj = this.generateRegoObject([product], undefined, undefined, this.selectedTeam);
          this.$store.commit('cart/setPendingRequiredRego', regoObj);
          const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
          this.$router.push({
            name: pathName,
            params: { membershipRequiredProducts: product.membershipProductsRequired },
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Cancelled',
          });
        });
        return;
      }

      if (fullSlot) {
        this.$notify({
          title: 'Full',
          message: 'This product is full.',
          type: 'warning',
          duration: 5000,
        });
        return;
      }
      if (product.type === 'indv-to-team') {
        if (this.selectedTeam) {
        // You might want to show some modal or UI component here for the user to choose a team
        // Example:
          console.log('selectedTeam', this.selectedTeam);
          const filteredProducts = this.localRegistration.product.filter((p) => p._id === product._id);
          const regoObj = this.generateRegoObject(filteredProducts, undefined, undefined, this.selectedTeam);
          console.log('regoObj', regoObj);
          const registrations = this.$store.getters['cart/registrations'];

          if (regoObj.registrationType === 'event') {
            const {
              _id: entityId, productType, memberType, tags, ageFrom, ageTo
            } = regoObj;

            const foundRego = _.find(registrations, (r) => r.entityId === entityId
                                && r.memberId === this.selectedmemberId
                                && r.productType === productType
                                && r.ageFrom === ageFrom
                                && r.ageTo === ageTo
                                && r.memberType === memberType
                                && _.isEqual(r.tags, tags));
            if (foundRego && productType !== 'indv-to-team') {
              this.$store.commit('loading', false);
              this.$message.error('Registration for this member has already been added to cart.');
              return;
            }

            if (foundRego && productType === 'indv-to-team') {
              const currentTeamId = regoObj.selectedTeam;
              const foundTeam = _.find(registrations, (t) => t.team && t.team._id === currentTeamId);
              if (foundTeam) {
                this.$store.commit('loading', false);
                this.$message.error('Registration for this member has already been added to cart.');
                return;
              }
            }

            if (regoObj.productType === 'indv') {
              this.$store.commit('loading', false);
              const pathName = this.hasCustomEntity ? 'custom-event-register-individual' : 'event-register-individual';
              this.$router.push({
                name: pathName,
                params: { criteria: this.criteria, memberId: this.selectedmemberId, selectedEvent: regoObj },
              });
            } else if (regoObj.productType === 'indv-to-team') {
              delete regoObj.teams;
              delete regoObj.selectedTeam;

              this.$store.commit('loading', false);
              const pathName = this.hasCustomEntity ? 'custom-event-register-individual-to-team' : 'event-register-individual-to-team';
              this.$router.push({
                name: pathName,
                params: { criteria: this.criteria, memberId: this.selectedmemberId, selectedEvent: regoObj },
              });
            } else {
              this.$store.commit('loading', false);
              this.$message.error('Registration for this product type is not available yet.');
            }
          }
        } else {
          this.$notify({
            title: 'No Teams Available',
            message: 'There are no teams available for this product.',
            type: 'warning',
            duration: 5000,
          });
        }
      }
    },
    generateRegoObject(filteredProducts, teamId, OrgId, team, customRego, entity) {
      const {
        acceptActiveKids, description, endDate, entityId, entityType, isRegoOpen, meta, registrationType, name, discounts,
        multipleRegoDiscounts, orgtree, regoEndDate, regoStartDate, saleableItems, additionalQs, startDate, teams, _id, isClubMembership, isRenewable, useDuration,
        durationYear, durationMonth, durationDay, isTCRequired, isTCPrefilled, requiresApproval
      } = customRego || this.localRegistration;
      const filteredAdditionalQs = additionalQs.filter((q) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive;
        }
        return _.includes(q.productTypes, filteredProducts[0].type) && q.isActive && _.includes(q.memberTypes, filteredProducts[0].memberType);
      });
      const filteredSaleableItems = saleableItems.filter((si) => {
        if (filteredProducts[0].type === 'team' || filteredProducts[0].type === 'entity') {
          return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive;
        }
        return _.includes(si.productTypes, filteredProducts[0].type) && si.isActive && _.includes(si.memberTypes, filteredProducts[0].memberType);
      });
      console.log('filteredSaleableItems', filteredSaleableItems);
      console.log('filteredAdditionalQs', filteredAdditionalQs);
      console.log('this.selectedMember', this.selectedMember);
      const regoObj = {
        acceptActiveKids,
        name,
        memberId: this.selectedMember._id,
        registrationType,
        isClubMembership,
        isRenewable,
        description,
        endDate,
        entityId,
        entityType,
        isRegoOpen,
        meta,
        entityLogo: _.get(meta, 'imgUrl', this.defaultRegoLogo),
        discounts,
        multipleRegoDiscounts,
        orgtree,
        products: filteredProducts,
        regoEndDate,
        regoStartDate,
        // filter saleable Items with matching product type and memberType and isActive
        saleableItems: filteredSaleableItems,
        additionalQs: filteredAdditionalQs,
        startDate,
        teams,
        _id,
        productType: filteredProducts[0].type,
        tags: filteredProducts[0].tags,
        useDuration,
        durationYear,
        durationMonth,
        durationDay,
        isTCRequired,
        isTCPrefilled,
        requiresApproval
      };
      if (filteredProducts[0].type !== 'team' || filteredProducts[0].type !== 'entity') {
        _.assign(regoObj, { memberType: filteredProducts[0].memberType });
      }
      if (teamId) {
        _.assign(regoObj, { selectedTeam: teamId });
      }
      if (OrgId) {
        _.assign(regoObj, { selectedEntity: OrgId });
      }
      if (team) {
        _.assign(regoObj, { team });
      }
      if (entity && entity._id) {
        _.assign(regoObj, { entity });
      }
      console.log('regoObj', regoObj);
      this.$store.commit('cart/setPendingRegistration', this.localRegistration._id);
      return regoObj;
    },
    isEligible(product) {
      if (this.selectedMember) {
        // find the registration product based on the productid
        // const foundProduct = this.localRegistration.product.find((p) => p._id === productId);
        if (product) {
          // check gender of the product  and calculate the age of the member and conpare with the age range of the product
          const {
            gender, ageFrom, ageTo,
          } = product;
          const { dob, gender: memberGender } = this.selectedMember.profile;
          const age = this.calculateAge(dob);
          if (ageFrom <= age && ageTo >= age && (memberGender === gender || gender === 'All' || !gender || (gender === 'Other' && (memberGender !== 'Male' && memberGender !== 'Female')))) {
            return true;
          }
          return false;
        }
      }
      return true;
    },
    calculateAge(dob) {
      const endOfYear = this.$store.getters['national/endOfYear'];
      const age = calculateMemberAge(dob, endOfYear);
      return age;
    },
    closeDialog() {
      this.showInviteModal = false;
      if (this.pendingNextAction) {
        this.pendingNextAction = false;
        const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
        this.$router.push({ name: pathName });
      }
    },
    generateTagSignature(tags) {
      return tags && tags.length > 0
        ? tags.map((tag) => tag._id).sort().join(',')
        : '';
    },
    isMembershipRequired(product) {
      if (product.type === 'team') return false;
      if (product.isMembershipRequired) {
        // Create sets of concatenated feature strings for efficient lookup
        const requiredFeatureStrings = new Set();
        const memberFeatureStrings = new Set();

        // Check if we need to validate against event start date
        const checkExpiryFromEvent = this.localRegistration?.meta?.checkExpiryFromEventStart === true;
        const eventStartDate = checkExpiryFromEvent ? moment(this.localRegistration.startDate).valueOf() : null;

        // Build a map to track which requirements need event date checking
        const requirementExpiryRules = new Map();

        // Build required membership feature strings
        product.membershipProductsRequired.forEach((pr) => {
          const tagSig = this.generateTagSignature(pr.products.tags);
          const featureString = pr.products._id
            ? `productId:${pr.products._id}|membershipId:${pr._id}`
            : `${pr._id}|${pr.products.type}|${pr.products.memberType}|${tagSig}`;

          requiredFeatureStrings.add(featureString);

          // Track if this requirement needs event date checking
          const needsEventDateCheck = checkExpiryFromEvent && eventStartDate;
          requirementExpiryRules.set(featureString, needsEventDateCheck ? eventStartDate : moment().valueOf());
        });

        // Build member membership feature strings and collect valid memberships
        const validMemberships = [];
        this.memberMembership.forEach((m) => {
          // Early exit for already expired memberships - they can't be valid for ANY date
          if (m.expired === true || m.expiry < moment().valueOf()
              || (m.approvalStatus && (m.approvalStatus === 'pending' || m.approvalStatus === 'declined'))) {
            return;
          }

          // Create feature strings for both product ID and legacy comparison
          const memberTagSig = this.generateTagSignature(_.get(m, 'regoEntity.products.tags', []));
          const memberFeatureString = `${m.entityId}|${m.productType}|${m.memberType}|${memberTagSig}`;
          const productIdFeatureString = m.productId ? `productId:${m.productId}|membershipId:${m.entityId}` : null;

          // Check if this membership matches any required membership and meets expiry requirements
          let isValidForRequirement = false;

          if (requiredFeatureStrings.has(memberFeatureString)) {
            // Check if membership expiry meets the requirement's specific date
            const requiredExpiryDate = requirementExpiryRules.get(memberFeatureString);
            if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
              isValidForRequirement = true;
            }
          }

          if (productIdFeatureString && requiredFeatureStrings.has(productIdFeatureString)) {
            const requiredExpiryDate = requirementExpiryRules.get(productIdFeatureString);
            if (requiredExpiryDate && m.expiry >= requiredExpiryDate) {
              isValidForRequirement = true;
            }
          }

          if (isValidForRequirement) {
            memberFeatureStrings.add(memberFeatureString);
            if (productIdFeatureString) {
              memberFeatureStrings.add(productIdFeatureString);
            }
            validMemberships.push(m);
          }
        });

        if (!validMemberships.length) {
          return true;
        }
      }
      return false;
    },
    updateButtonStatus(status) {
      this.isNextDisabled = status;
    },
    async updateStep(val, step = 1) {
      _.assign(this.registration, val);
      console.log('this.registration', this.registration);

      if (step > 0) {
        // Check for duplicate team name in cart when moving from team details step
        if (this.step === 0 && step === 1) {
          const cartRegistrations = this.$store.getters['cart/registrations'] || [];
          const isDuplicateTeam = cartRegistrations.some((item) => item.team
            && item.team.name === this.registration.team.name
            && item.product._id === this.registration.product._id);

          if (isDuplicateTeam) {
            this.$confirm(
              'A team with this name is already in your cart for this product. Would you like to go to checkout instead?',
              'Duplicate Team',
              {
                confirmButtonText: 'Go to Checkout',
                cancelButtonText: 'Stay Here',
                type: 'warning'
              }
            ).then(() => {
              // User chose to go to checkout
              const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
              this.$router.push({ name: pathName });
            }).catch(() => {
              // User chose to stay on current page
              this.$message({
                type: 'info',
                message: 'Please use a different team name'
              });
            });
            return;
          }
        }

        if (step !== 3) this.step += step;
        if (this.step === 1 && !this.hasAdditionalQs) this.step += 1;
        if (this.step === 2 && !this.hasSaleableItems) this.step += 1;
        if (this.step === 3) {
          this.$store.commit('cart/add', this.registration);

          // Route to the global payment page
          // commit rego to store
          this.$confirm('Do you want to also register to this team?', 'Confirmation', {
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            type: 'warning'
          }).then(async () => {
            const activeMember = this.$store.getters['user/activeMember'];
            if (activeMember && activeMember._id) {
              this.selectedmemberId = activeMember._id;
            }
            const criteria = this.registration.eventId;
            const filters = {
              ageFrom: 1,
              ageTo: 100,
              eventDateRange: [],
              memberId: this.selectedmemberId,
              regoOpen: 'open',
            };
            console.log('this.selectedmemberId', this.selectedmemberId);
            this.selectedMember = this.memberList.find((m) => m._id === this.selectedmemberId);
            this.$store.commit('loading', { loading: true, text: 'Loading products...' });
            const response = await this.$http.get(`/assemble/api/v1/portal/registrations/members/${this.selectedmemberId}`);
            this.memberMembership = response.data.data;
            const resSearch = await this.$http.post('/assemble/api/v1/portal/registrations/new-search/20/1', {
              criteria: _.trim(criteria),
              filters,
            });
            [this.localRegistration] = resSearch.data.data.result;
            const teamProduct = this.registration.product;
            this.teamProducts = this.localRegistration.product.filter((product) => product.type === 'indv-to-team' && product.ageFrom === teamProduct.ageFrom && product.ageTo === teamProduct.ageTo && (product.gender === teamProduct.gender || teamProduct.gender === 'All' || !teamProduct.gender || (teamProduct.gender === 'Other' && (product.gender !== 'Male' || product.gender !== 'Female'))));
            this.selectedTeam = this.registration.team;
            console.log('this selected team', this.selectedTeam);
            this.showInviteModal = true;
            this.pendingNextAction = true;
            this.$store.commit('loading', false);
          }).catch(() => {
            const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
            this.$router.push({ name: pathName });
            this.$store.commit('loading', false);
          });
        }
      }
      if (step < 0) {
        if (step !== 3) this.step += step;
        if ((this.step === 2) && !this.hasSaleableItems) this.step -= 1;
        if (this.step === 1 && !this.hasAdditionalQs) this.step -= 1;
      }
      this.isNextDisabled = false;
    },
    cancel() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
    },
    back() {
      const pathName = this.hasCustomEntity ? 'custom-finder' : 'finder';
      if (this.step === 0) this.$router.push({ name: pathName, params: { defaultCriteria: this.criteria } });
      else this.$refs.rego.updateStep(-1);
    },
    next() {
      if (this.$refs.rego) {
        this.$refs.rego.updateStep(1);
      } else if (this.step === 3) {
        const pathName = this.hasCustomEntity ? 'custom-payment' : 'payment';
        this.$router.push({ name: pathName });
      }
    },
  },
  computed: {
    hasCustomEntity() {
      const customEntity = this.$store.getters['national/getEntity'];
      if (customEntity && customEntity.level && customEntity.name) {
        return true;
      }
      return false;
    },
    hasAdditionalQs() {
      return this.registration.additionalQs && this.registration.additionalQs.length;
    },
    hasSaleableItems() {
      return this.registration.saleableItems && this.registration.saleableItems.length;
    }
  }
};
</script>

<style scoped lang="scss">
.main-content {
  width: 90%;
  max-width: $md;

  // .content-body {
  //   width: 100%;
  // }
  // .payment-card {
  //   border: 1
  // }

  .bottomBtn {
    max-width: 100%;
    width: 12em;
  }

  @media screen and (device-aspect-ratio: 40/71) {
    .bottomBtn {
      font-size: 0.8em;
    }
    .respBtn {
      font-size: 0.75em !important;
    }
  }

  .disabled-next {
    background: rgba($highlight, 0.7);
    border: 0 !important;
    cursor: pointer !important;
  }
}
.product-container-main-mobile{

&::v-deep.el-card__body {
  padding: 0.5rem !important;
}

  .product-description{
    display: grid;
    // justify-content: space-between;
    margin: 11px 0 0 0;
    padding: 0 1rem;
    gap: 0.5rem;

    .dark-color{
      background: #c4c4c4;
    }
    .member-type{
      flex-basis: 50%;
    }
    .gender{
      flex-basis: 30%;
    }
    .age{
      flex-basis: 20%;
    }
    .product-displayName{
      display: flex;
      align-items: center;
      justify-content: flex-start;
      opacity: 0.6;
      font-style: normal;
      font-weight: 500;
      font-size: 1rem;
      line-height: 1.8rem;
      // limit line to 5
      .max-lines {
        /* Set a height for the container */
        max-height: 9rem; /* 5 lines x 0.75rem line height */
        overflow: hidden;
        font-style: normal;
        font-weight: 700;
        font-size: 1.2rem;
        line-height: 1.8rem;
        display: -webkit-box;
        -webkit-line-clamp: 5;
        -webkit-box-orient: vertical;
      }
      .max-lines p {
        margin: 0; /* remove any margin that may be applied to the p tag by default */
        line-height: 1.8rem; /* set the desired line height */
      }

    }

    .product-tags{
      align-items: center;
      display: flex;
      span{
        font-family: $fontBold !important;
        font-weight: 700;
        font-size: 15px;
        line-height: 25px;
        letter-spacing: -0.5px;
        color: #303133;
        opacity: 0.6;
      }
      overflow: hidden;
      word-break: break-word !important;
    }
    .product-price{
      font-style: normal;
      font-weight: 400;
      font-size: 1rem;
      line-height: 1.8rem;
      display: flex;
      align-items: center;
      letter-spacing: -0.5px;
      color: #303133;
    }
  }
  .grid-style{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .product-register{
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    // justify-content: flex-end;
    // flex-direction: column;
    .secondary-type-button{
      background: var(--secondary-color);
      color: #000;
      &:hover{
        // hover color to higher contrast
        background: var(--secondary-color);
        opacity: 0.8;
        color: #000;
      }
    }
    .primary-type-button{
      margin: 0;
      // display: flex;
      // border-radius: 50px;
      // text-align: center;
      // align-items: center;
      // justify-content: center;
      // margin-bottom: 10px;
    }
  }
}
</style>
